import { InsertPageBreak } from '@mui/icons-material';
import { Document, Image, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#FFF',
        flexWrap: 'wrap'
    },
    logoWrapper: {
        display: 'flex',
        width: '100%',
        height: 90,
        alignItems: 'center'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    image: {
        marginVertical: 15,
        marginHorizontal: 20,
        width: 100
    },
    table: { borderColor: '#adadad', display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderRightWidth: 0, borderBottomWidth: 0 },
    tableRow: { borderColor: '#adadad', margin: "auto", flexDirection: "row" },
    spanCol: { borderColor: '#adadad', width: "100%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, paddingBottom: 5, textAlign: 'center' },
    tableCol: { borderColor: '#adadad', width: "80%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, paddingBottom: 5 },
    tableCol1: { borderColor: '#adadad', width: "20%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, paddingBottom: 5 },
    pricingTableCol: { width: "80%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, paddingBottom: 5 },
    tableCell: {margin: "auto", marginTop: 5, fontSize: 8 }
});

const currencyMap = {
    'USD': '$',
    'EUR': '€'
}



function renderPdfQuote(quote, index, t, user, expiration, promo){

    function isNotClassicAssistant () {
        if (!quote || !quote.quote) return false
        return (quote.quote.product === 'ASSISTANT_LEI' || quote.quote.product === 'ASSISTANT_BUS')
    }

    return <Page key={index} size="A4" style={styles.page}>
    <View style={{position: 'relative'}}>
        <View style={styles.logoWrapper}>
        <Image
            style={styles.image}
            src="/logo.png"
        />
        </View>

        <View style={{
            width: '100%',
            flexDirection: 'column',
            paddingLeft: 80,
            paddingRight: 80,
            marginTop: -25,
            marginBottom: 20
        }}>
            <View style={{
                marginBottom: 10
            }}>

                <View>
                    <Text style={{
                        fontSize: 10,
                        fontFamily: 'Helvetica-Bold',
                        marginBottom: '5px',
                        color: '#4d4d4d',
                        textAlign: 'right'
                    }}>{t('customer')}</Text>

                    <Text style={{
                        fontSize: 12,
                        textAlign: 'right'
                    }}>{user.name}</Text>
                    <Text style={{
                        fontSize: 10,
                        color: '#4d4d4d',
                        textAlign: 'right'
                    }}>{user.email}</Text>
                    <Text style={{
                        fontSize: 10,
                        color: '#4d4d4d',
                        textAlign: 'right'
                    }}>{expiration ? t('expiringdate'):''} <Text style={{fontFamily: 'Helvetica-Bold'}}>{expiration ? expiration : ''}</Text></Text>
                </View>

                <View>
                    <Text style={{
                        fontSize: 10,
                        fontFamily: 'Helvetica-Bold',
                        marginBottom: '5px',
                        color: '#4d4d4d'
                    }}>{t('hotel')}</Text>

                    <Text style={{
                        fontSize: 12
                    }}>{quote.name}</Text>
                </View>

            </View>

            <View style={{
                marginTop: 5,
                marginBottom: 5,
            }}>
                <Text style={{
                    fontSize: 15,
                    color: '#3cb0a9'
                }}>
                    { (quote.product === 'ASSISTANT_BUS') && t('products.business') }
                    { (quote.product === 'ASSISTANT_LEI') && t('products.leisure') }
                    { (quote.product === 'ASSISTANT')  && t('products.forYou')}
                    { (quote.product === 'ADVISOR')  && t('products.advisor')}
                </Text>
            </View>


            <View style={{
                marginTop: 10,
                marginBottom: 8,
            }}>
                <Text style={{
                    color: '#3cb0a9',
                    fontSize: 10
                }}>
                    {t('modules.title')}
                </Text>
            </View>

            <View style={{
            }}>
                <View style={styles.table}>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.displacementModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.displacement ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.financeModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.financial ? '/check.png' : '/cross.png'} 
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.flightsModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.flights ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>


                    {
                        (quote && quote.country === 'Italy') &&
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol}>
                                <Text style={{
                                    ...styles.tableCell,
                                    textAlign: 'left',
                                    display: 'block',
                                    width: '100%',
                                    paddingLeft: 10,
                                    paddingRight: 10
                                }}>{t('modules.eyeModule')}</Text>
                            </View>
                            <View style={styles.tableCol1}>
                                <Text style={styles.tableCell}>
                                    <Image
                                        style={{
                                            marginVertical: 0,
                                            marginHorizontal: 0
                                        }}
                                        src={'/check.png'}
                                    />
                                </Text>
                            </View>
                        </View>
                    }

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.gapModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.gapAnalysis ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.autopilotFunctionality')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.autopilot ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.gridModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.rateGrid ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.biModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.bi ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.rmsModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.rms ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>


                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.commissionsFunctionality')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.commission ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.rateCheckerModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.rateChecker ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.marketingModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={'/check.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.rateShopperModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={'/check.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.criFunctionality')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={'/check.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.calendarModule')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={'/check.png'}
                                />
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('modules.restrictions')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={quote.restrictions ? '/check.png' : '/cross.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    
                </View>
            </View>


            <View style={{
                marginTop: 15,
                marginBottom: 8,
            }}>
                <Text style={{
                    color: '#3cb0a9',
                    fontSize: 10
                }}>
                    {t('integratedRateShopper.title')}
                </Text>
            </View>


            <View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.hotel')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                1
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.compset')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                {quote.competitor}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.channel')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                1
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.roomTypes')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                {quote.roomTypes}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.minLos')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={'/check.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.daysout')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                120
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.dailyshop')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                1
                            </Text>
                        </View>
                    </View>
                    
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.daysoutW')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                365
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.weeklyshop')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                1
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.daysoutD')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                120
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.ondemandShop')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={'/check.png'}
                                />
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={{
                                ...styles.tableCell,
                                textAlign: 'left',
                                display: 'block',
                                width: '100%',
                                paddingLeft: 10,
                                paddingRight: 10
                            }}>{t('integratedRateShopper.loginUpdate')}</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.tableCell}>
                                <Image
                                    style={{
                                        marginVertical: 0,
                                        marginHorizontal: 0
                                    }}
                                    src={'/check.png'}
                                />
                            </Text>
                        </View>
                    </View>
                    
                </View>
            </View>
        </View>

        <Image
        src="/quotebg.jpg"
        style={{
            position: 'absolute',
            zIndex: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            minWidth: '100%',
            maxHeight: '100%'
        }}></Image>
    </View>
    {/* PAGE 2 */}
    <View break style={{position: 'relative'}}>
        <View style={styles.logoWrapper}>
            <Image
                style={styles.image}
                src="/logo.png"
            />
        </View>
        <View style={{
            width: '100%',
            flexDirection: 'column',
            paddingLeft: 80,
            paddingRight: 80,
            marginTop: -25,
            marginBottom: 20
        }}>
            {
                quote.rateChecker  &&
                <View>
                    <View style={{
                        marginTop: 15,
                        marginBottom: 8,
                    }}>
                        <Text style={{
                            color: '#3cb0a9',
                            fontSize: 10
                        }}>
                            {t('rateChecker.title')}
                        </Text>
                    </View>

                    <View style={{ }}>
                        
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('rateChecker.properties')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        {quote.hotels}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('rateChecker.channels')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        {quote.channels}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('rateChecker.los')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        {quote.los}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('rateChecker.daysout')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        {quote.daysOut}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('rateChecker.dailyShop')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        {quote.dailyFrequency}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('rateChecker.daysoutW')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        {quote.daysOutW}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('rateChecker.weeklyshop')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        {quote.weeklyFrequency}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            }


            {
                (quote && quote.country === 'Italy') &&
                
                <View>
                    <View style={{
                    marginTop: 15,
                    marginBottom: 8,
                    }}>
                        <Text style={{
                            color: '#3cb0a9',
                            fontSize: 10
                        }}>
                            {t('services.title')}
                        </Text>
                    </View>
                    
                    <View style={{
                    }}>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('services.consultancy')}</Text>
                                </View>
                                <View style={styles.tableCol1}>
                                    <Text style={styles.tableCell}>
                                        <Image
                                            style={{
                                                marginVertical: 0,
                                                marginHorizontal: 0
                                            }}
                                            src={quote.consultancy ? '/check.png' : '/cross.png'}
                                        />
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>     
                </View> 
            }

            {
                (quote && quote.promo !== '' && promo) &&
                
                <View>
                    <View style={{
                    marginTop: 15,
                    marginBottom: 8,
                    }}>
                        <Text style={{
                            color: '#3cb0a9',
                            fontSize: 10
                        }}>
                           {t('promo.title')} {quote.promo}
                        </Text>
                    </View>
                    
                    <View>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.spanCol}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'center',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{promo.description}</Text>
                                </View>
                            </View>
                            {
                             promo.setupDiscount &&
                                <View style={styles.tableRow}>
                                    <View style={{...styles.tableCol, width:'50%'}}>
                                        <Text style={{
                                        ...styles.tableCell,
                                        display: 'block',
                                        width: '100%',
                                        textAlign: 'left',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('promo.setupDiscount')}</Text>
                                    </View>
                                    <View style={{...styles.tableCol, width:'50%'}}>
                                        <Text style={{
                                        ...styles.tableCell,
                                        display: 'block',
                                        width: '100%',
                                        textAlign: 'right',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{promo.setupDiscount*100}%</Text>
                                    </View>
                                </View>
                            }
                            {
                             promo.additionalMonths &&
                                <View style={styles.tableRow}>
                                    <View style={{...styles.tableCol, width:'50%'}}>
                                        <Text style={{
                                        ...styles.tableCell,
                                        display: 'block',
                                        width: '100%',
                                        textAlign: 'left',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('promo.additionalMonths')}</Text>
                                    </View>
                                    <View style={{...styles.tableCol, width:'50%'}}>
                                        <Text style={{
                                        ...styles.tableCell,
                                        display: 'block',
                                        width: '100%',
                                        textAlign: 'right',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{promo.additionalMonths}</Text>
                                    </View>
                                </View>
                            }
                            {
                             promo.freeMonth &&
                                <View style={styles.tableRow}>
                                    <View style={{...styles.tableCol, width:'50%'}}>
                                        <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'left',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('promo.extraDiscount')}</Text>
                                    </View>
                                    <View style={{...styles.tableCol, width:'50%'}}>
                                        <Text style={{
                                        ...styles.tableCell,
                                        textAlign: 'right',
                                        display: 'block',
                                        width: '100%',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{Math.round(quote.totals.month)} {currencyMap[quote.currency]} {quote.properties > 1 && t('quote.single')}</Text>
                                    <Text style={{
                                        ...styles.tableCell,
                                        display: 'block',
                                        width: '100%',
                                        fontSize: 8,
                                        color: 'gray',
                                        textAlign: 'right',
                                        paddingLeft: 10,
                                        paddingRight: 10
                                    }}>{t('promo.freeMonth')}</Text>
                                    </View>
                                </View>
                            }
                        </View>
                    </View> 
                </View>
            }

            <View style={{
                marginTop: 20,
                marginBottom: 5
            }}>
                <Text style={{
                    color: '#3cb0a9',
                    textAlign: 'center'
                }}>
                    {t('quote.pricing')}
                </Text>
                {quote.properties > 1 &&
                <Text style={{
                    fontSize: 8,
                    color: 'gray',
                    textAlign: 'center',
                }}>{t('quote.single')}</Text> 
                }
            </View>

            <View style={{
                marginBottom: 10,
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            }}>
                <Text style={{
                    fontSize: 14
                }}>{t('setupFee')} {quote.totals.setup.toFixed(0)} {currencyMap[quote.currency]}</Text>
                {
                    (quote.totals.originSetup > quote.totals.setup) &&
                    <Text style={{
                        marginLeft: 5,
                        textAlign: 'center',
                        fontSize: 12,
                        textDecoration: 'line-through'
                    }}>{quote.totals.originSetup} {currencyMap[quote.currency]}</Text>
                }
            </View>

            <View style={{
                marginBottom: 3
            }}>
                <View style={{
                    ...styles.table,
                    backgroundColor: '#94e0dc',
                    borderRadius: 10,
                    border: 0,
                    color: '#1a524e'
                }}>
                    <View style={styles.tableRow}>
                        <View style={{
                            ...styles.pricingTableCol,
                            width: '33.33%',
                            border: 0,
                            borderRight: 2,
                            borderColor: '#FFFFFF',
                            paddingTop: 4,
                        }}>
                            <Text style={{
                                ...styles.tableCell,
                                fontSize: 12
                            }}>{t('monthly')}</Text>
                        </View>
                        <View style={{
                            ...styles.pricingTableCol,
                            width: '33.33%',
                            border: 0,
                            borderRight: 2,
                            borderColor: '#FFFFFF',
                            paddingTop: 4,
                        }}>
                            <Text style={{
                                ...styles.tableCell,
                                fontSize: 12
                            }}>{t('semester')}</Text>
                        </View>
                        <View style={{
                            ...styles.pricingTableCol,
                            width: '33.33%',
                            border: 0,
                            paddingTop: 4,
                        }}>
                            <Text style={{
                                ...styles.tableCell,
                                fontSize: 12
                            }}>{t('year')}</Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={{
                            ...styles.pricingTableCol,
                            width: '33.33%',
                            border: 0,
                            borderRight: 2,
                            borderColor: '#FFFFFF',
                            paddingBottom: 8,
                        }}>
                            <Text style={{
                                ...styles.tableCell,
                                fontSize: 18
                            }}>{quote.totals.month.toFixed(0)} {currencyMap[quote.currency]}</Text>
                            {
                                (quote.totals.originMonth > quote.totals.month) &&
                                <Text style={{
                                    ...styles.tableCell,
                                    fontSize: 12,
                                    textDecoration: 'line-through'
                                }}>{quote.totals.originMonth.toFixed(0)} {currencyMap[quote.currency]}</Text>
                            }
                            {
                                (quote.totals.originMonth === 0) &&
                                <Text style={{
                                    ...styles.tableCell,
                                    fontSize: 12,
                                    textDecoration: 'line-through'
                                }}>{Math.round(quote.totals.month/0.9)} {currencyMap[quote.currency]}</Text>
                            }
                        </View>
                        <View style={{
                            ...styles.pricingTableCol,
                            width: '33.33%',
                            border: 0,
                            borderRight: 2,
                            borderColor: '#FFFFFF',                                    
                            paddingBottom: 8,
                        }}>
                            <Text style={{
                                ...styles.tableCell,
                                fontSize: 18
                            }}>{quote.totals.semester.toFixed(0)} {currencyMap[quote.currency]}</Text>
                            {
                                (quote.totals.originSemester > quote.totals.semester) &&
                                <Text style={{
                                    ...styles.tableCell,
                                    fontSize: 12,
                                    textDecoration: 'line-through'
                                }}>{quote.totals.originSemester.toFixed(0)} {currencyMap[quote.currency]}</Text>
                            }
                            {
                                (quote.totals.originSemester === 0) &&
                                <Text style={{
                                    ...styles.tableCell,
                                    fontSize: 12,
                                    textDecoration: 'line-through'
                                }}>{Math.round(quote.totals.semester/0.9)} {currencyMap[quote.currency]}</Text>
                            }
                        </View>
                        <View style={{
                            ...styles.pricingTableCol,
                            width: '33.33%',
                            border: 0,
                            paddingBottom: 8,
                        }}>
                            <Text style={{
                                ...styles.tableCell,
                                fontSize: 18
                            }}>{quote.totals.annual.toFixed(0)} {currencyMap[quote.currency]}</Text>
                            {
                                (quote.totals.originAnnual > quote.totals.annual) &&
                                <Text style={{
                                    ...styles.tableCell,
                                    fontSize: 12,
                                    textDecoration: 'line-through'
                                }}>{quote.totals.originAnnual.toFixed(0)} {currencyMap[quote.currency]}</Text>
                            }
                            {
                                (quote.totals.originAnnual === 0) &&
                                <Text style={{
                                    ...styles.tableCell,
                                    fontSize: 12,
                                    textDecoration: 'line-through'
                                }}>{Math.round(quote.totals.annual/0.9)} {currencyMap[quote.currency]}</Text>
                            }
                        </View>
                    </View>
                </View>
            </View>
            
            { (quote.properties > 1) &&
                <View>
                    <View style={{
                        marginTop: 20,
                        marginBottom: 5
                    }}>
                        <Text style={{
                            color: '#3cb0a9',
                            textAlign: 'center'
                        }}>
                                {t('quote.total')}
                        </Text>
                        {quote.properties > 1 &&
                        <Text style={{
                            fontSize: 8,
                            color: 'gray',
                            textAlign: 'center',
                        }}>{quote.properties} {t('quote.properties')}</Text> 
                        }
                    </View>

                    <View style={{
                        marginBottom: 10,
                        color: '#4d4d4d',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Text style={{
                            fontSize: 14
                        }}>{t('setupFee')} {quote.totals.setup.toFixed(0)*quote.properties} {currencyMap[quote.currency]}</Text>
                        {
                            (quote.totals.originSetup > quote.totals.setup) &&
                            <Text style={{
                                marginLeft: 5,
                                textAlign: 'center',
                                fontSize: 12,
                                textDecoration: 'line-through'
                            }}>{quote.totals.originSetup*quote.properties} {currencyMap[quote.currency]}</Text>
                        }
                    </View>

                    <View style={{
                        marginBottom: 3
                    }}>
                        <View style={{
                            ...styles.table,
                            backgroundColor: '#94e0dc',
                            borderRadius: 10,
                            border: 0,
                            color: '#1a524e'
                        }}>
                            <View style={styles.tableRow}>
                                <View style={{
                                    ...styles.pricingTableCol,
                                    width: '33.33%',
                                    border: 0,
                                    borderRight: 2,
                                    borderColor: '#FFFFFF',
                                    paddingTop: 4,
                                }}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        fontSize: 12
                                    }}>{t('monthly')}</Text>
                                </View>
                                <View style={{
                                    ...styles.pricingTableCol,
                                    width: '33.33%',
                                    border: 0,
                                    borderRight: 2,
                                    borderColor: '#FFFFFF',
                                    paddingTop: 4,
                                }}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        fontSize: 12
                                    }}>{t('semester')}</Text>
                                </View>
                                <View style={{
                                    ...styles.pricingTableCol,
                                    width: '33.33%',
                                    border: 0,
                                    paddingTop: 4,
                                }}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        fontSize: 12
                                    }}>{t('year')}</Text>
                                </View>
                            </View>

                            <View style={styles.tableRow}>
                                <View style={{
                                    ...styles.pricingTableCol,
                                    width: '33.33%',
                                    border: 0,
                                    borderRight: 2,
                                    borderColor: '#FFFFFF',
                                    paddingBottom: 8,
                                }}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        fontSize: 18
                                    }}>{quote.totals.month.toFixed(0)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    {
                                        (quote.totals.originMonth > quote.totals.month) &&
                                        <Text style={{
                                            ...styles.tableCell,
                                            fontSize: 12,
                                            textDecoration: 'line-through'
                                        }}>{quote.totals.originMonth.toFixed(0)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    }
                                    {
                                        (quote.totals.originMonth === 0) &&
                                        <Text style={{
                                            ...styles.tableCell,
                                            fontSize: 12,
                                            textDecoration: 'line-through'
                                        }}>{Math.round(quote.totals.month/0.9)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    }
                                </View>
                                <View style={{
                                    ...styles.pricingTableCol,
                                    width: '33.33%',
                                    border: 0,
                                    borderRight: 2,
                                    borderColor: '#FFFFFF',                                    
                                    paddingBottom: 8,
                                }}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        fontSize: 18
                                    }}>{quote.totals.semester.toFixed(0)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    {
                                        (quote.totals.originSemester > quote.totals.semester) &&
                                        <Text style={{
                                            ...styles.tableCell,
                                            fontSize: 12,
                                            textDecoration: 'line-through'
                                        }}>{quote.totals.originSemester.toFixed(0)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    }
                                    {
                                        (quote.totals.originSemester === 0) &&
                                        <Text style={{
                                            ...styles.tableCell,
                                            fontSize: 12,
                                            textDecoration: 'line-through'
                                        }}>{Math.round(quote.totals.semester/0.9)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    }
                                </View>
                                <View style={{
                                    ...styles.pricingTableCol,
                                    width: '33.33%',
                                    border: 0,
                                    paddingBottom: 8,
                                }}>
                                    <Text style={{
                                        ...styles.tableCell,
                                        fontSize: 18
                                    }}>{quote.totals.annual.toFixed(0)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    {
                                        (quote.totals.originAnnual > quote.totals.annual) &&
                                        <Text style={{
                                            ...styles.tableCell,
                                            fontSize: 12,
                                            textDecoration: 'line-through'
                                        }}>{quote.totals.originAnnual.toFixed(0)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    }
                                    {
                                        (quote.totals.originAnnual === 0) &&
                                        <Text style={{
                                            ...styles.tableCell,
                                            fontSize: 12,
                                            textDecoration: 'line-through'
                                        }}>{Math.round(quote.totals.annual/0.9)*quote.properties} {currencyMap[quote.currency]}</Text>
                                    }
                                </View>
                            </View>
                        </View>
                    </View>

                </View>
            }

            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            }}>
                <Text style={{
                    fontSize: 10
                }}>{t('excludedVat')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            }}>
                <Text style={{
                    fontSize: 10
                }}>{t('excludedCostsPms')}</Text>
            </View>

            
            
        </View>

        <Image
        src="/quotebg.jpg"
        style={{
            position: 'absolute',
            zIndex: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            minWidth: '100%',
            maxHeight: '100%'
        }}></Image>
    </View>
    
</Page>

}


function renderDescriptions(t){

    return <Page size="A4" style={styles.page}>
        <View style={{position: 'relative'}}>
        <View style={styles.logoWrapper}>
            <Image
                style={styles.image}
                src="/logo.png"
            />
        </View>

        <View style={{
            width: '100%',
            flexDirection: 'column',
            paddingLeft: 80,
            paddingRight: 80,
            marginTop: -25,
            marginBottom: 20
        }}>
            <View style={styles.logoWrapper}>
                <Image
                    style={{
                        marginTop: 0,
                        marginBottom: 5,
                        marginHorizontal: 20,
                        width: 100
                    }}
                    src="/assistant.png"
                />
            </View>

            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                marginVertical: 5,
                marginTop: -30
            }}>
                <Text style={{
                    fontSize: 10
                }}>{t('descriptions.lybra')}</Text>
            </View>

            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                marginVertical: 5,
                marginTop: 15
            }}>
                <Text style={{
                    color: '#3cb0a9',
                    fontSize: 14,
                    textAlign: 'center'
                }}>{t('descriptions.keyPoints.title')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                <Text style={{
                    fontSize: 10
                }}>{t('descriptions.keyPoints.key1')}</Text>

            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                <Text style={{
                    fontSize: 10
                }}>{t('descriptions.keyPoints.key2')}</Text>

            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                <Text style={{
                    fontSize: 10
                }}>{t('descriptions.keyPoints.key3')}</Text>

            </View>
        </View>

        <View style={{
            width: '100%',
            flexDirection: 'column',
            paddingLeft: 80,
            paddingRight: 80,
            marginTop: -25,
            marginBottom: 20
        }}>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                marginVertical: 5,
                marginTop: 20
            }}>
                <Text style={{
                     color: '#3cb0a9',
                     fontSize: 14,
                     textAlign: 'center'
                }}>{t('modules.title')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.displacementModule')}:</Text> {t('descriptions.modules.displacementModule')}</Text>
            </View> 
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.financeModule')}:</Text> {t('descriptions.modules.financeModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.flightsModule')}:</Text> {t('descriptions.modules.flightsModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.eyeModule')}:</Text> {t('descriptions.modules.eyeModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.gapModule')}:</Text> {t('descriptions.modules.gapModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.autopilotFunctionality')}:</Text> {t('descriptions.modules.autopilotFunctionality')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.gridModule')}:</Text> {t('descriptions.modules.gridModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.biModule')}:</Text> {t('descriptions.modules.biModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.rmsModule')}:</Text> {t('descriptions.modules.rmsModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.commissionsFunctionality')}:</Text> {t('descriptions.modules.commissionsFunctionality')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.rateCheckerModule')}:</Text> {t('descriptions.modules.rateCheckerModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.marketingModule')}:</Text> {t('descriptions.modules.marketingModule.intro')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5,
                marginLeft: 15
            }}>
                    <Text style={{
                        fontSize: 10
                    }}>• {t('descriptions.modules.marketingModule.el1')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5,
                marginLeft: 15
            }}>
                    <Text style={{
                        fontSize: 10
                    }}>• {t('descriptions.modules.marketingModule.el2')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5,
                marginLeft: 15
            }}>
                    <Text style={{
                        fontSize: 10
                    }}>• {t('descriptions.modules.marketingModule.el3')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5,
                marginLeft: 15
            }}>
                    <Text style={{
                        fontSize: 10
                    }}>• {t('descriptions.modules.marketingModule.el4')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5,
                marginLeft: 15
            }}>
                    <Text style={{
                        fontSize: 10
                    }}>• {t('descriptions.modules.marketingModule.el5')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5,
                marginLeft: 15
            }}>
                    <Text style={{
                        fontSize: 10
                    }}>• {t('descriptions.modules.marketingModule.el6')}</Text>
            </View>
            
        </View>

        <Image
        src="/quotebg.jpg"
        style={{
            position: 'absolute',
            zIndex: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            minWidth: '100%',
            maxHeight: '100%'
        }}></Image>
    </View>
    <View break style={{position: 'relative'}}>
        <View style={styles.logoWrapper}>
            <Image
                style={styles.image}
                src="/logo.png"
            />
        </View>
        <View style={{
            width: '100%',
            flexDirection: 'column',
            paddingLeft: 80,
            paddingRight: 80,
            marginTop: -25,
            marginBottom: 20
        }}>           
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.rateShopperModule')}:</Text> {t('descriptions.modules.rateShopperModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.criFunctionality')}:</Text> {t('descriptions.modules.criFunctionality')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.calendarModule')}:</Text> {t('descriptions.modules.calendarModule')}</Text>
            </View>
            <View style={{
                color: '#4d4d4d',
                display: 'flex',
                flexDirection: 'row',
                marginVertical: 5
            }}>
                    <Text style={{
                        fontSize: 10
                    }}><Text style={{color: '#3cb0a9'}}>{t('modules.restrictions')}:</Text> {t('descriptions.modules.restrictions')}</Text>
            </View>
        </View>
        <Image
        src="/quotebg.jpg"
        style={{
            position: 'absolute',
            zIndex: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            minWidth: '100%',
            maxHeight: '100%'
        }}></Image>
    </View>
    </Page>
}

export default function Quote({
    user,
    quote,
    expiration,
    promos
}) {

    const { t } = useTranslation()

    return (
        <Document>
            {
                renderPdfQuote(quote,0, t, user, expiration, (quote.promo && quote.promo !== '') ? promos[quote.promo]:undefined)
            }
            {
                quote.subQuotes && quote.subQuotes.length > 0 && quote.subQuotes.map((sub, index) => (
                    renderPdfQuote(sub,(index+1), t, user,expiration, (sub.promo && sub.promo !== '') ? promos[sub.promo]:undefined)
                ))
            }
            {
                renderDescriptions(t)
            }
        </Document>
    )

}